import React, {
    useContext,
    useEffect,
    useState,
} from "react"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import {
    NavDropdown,
} from "react-bootstrap"

import {
    useAuthenticator,
} from "@aws-amplify/ui-react"

import {
    fetchUserAttributes,
} from "aws-amplify/auth"

import EMETLUserSettings from "../EMETLUserSettings"

const EMETLNavbarDropdown = () => {
    const {
        modal: {
            setContent,
            setTitle,
        },
    } = useContext(Context)

    const [name, setName] = useState<string>("")

    const handleShow =  () => {
        setTitle("User Settings")
        setContent(
            <EMETLUserSettings 
                handleClose={() => {
                    setContent(null)
                    setTitle("")
                }}
            />
        )
    }

    const load = async () => {
        const userAttributes = await fetchUserAttributes()
        setName(userAttributes?.name || "EMETL User")
    }

    useEffect(() => {
        load()
    }, [])

    return (
        <NavDropdown 
            title={`Welcome, ${name}`} 
        >
            <NavDropdown.Item href="#Profile">My Profile</NavDropdown.Item>
            <NavDropdown.Item href="#Tutorial">Tutorial</NavDropdown.Item>
            <NavDropdown.Item href="#About">About</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item 
                onClick={handleShow}
            >
                User Settings
            </NavDropdown.Item>
        </NavDropdown>
    )
}

export default EMETLNavbarDropdown